import { connect } from "react-redux";
import * as React from "react";
import Component from "../../AbstractComponent";

interface StateInterface {
}

class Message extends Component {
  public state: StateInterface = {
  };

  constructor(public props) {
    super(props);
  }

  public render() {
    return (
			<div 
				className={`message-wrapper ${this.props.isOutgoing ? "outgoing" : "incoming"}`}
			>
				<div 
          className="message-inner-wrapper" 
          style={{paddingBottom: this.props.message?.isEmailNotificationFailed && this.props.message?.isSmsNotificationFailed ? 
                    "30px" : this.props.message?.isEmailNotificationFailed || this.props.message?.isSmsNotificationFailed ? "20px" : "10px"
          }}
        >
					<div className="header">
            {
              !this.props.isOutgoing && (
                <React.Fragment>
                  <div className="name">{this.props.message?.senderDisplayName}</div>
                  <div className="date">{this.formatter.formatDate(this.props.message?.createdAt)}</div>
                </React.Fragment>
              )
            }
            {
              this.props.isOutgoing && (
                <React.Fragment>
                  <div className="date">{this.formatter.formatDate(this.props.message?.createdAt)}</div>
                  <div className="name">{this.props.message?.senderDisplayName}</div>
                </React.Fragment>
              )
            }
					</div>
					<div className="message">
            {this.props.message?.message}
            <div className="time">
              {this.formatter.formatTime(this.props.message?.createdAt)}
            </div>
          </div>
					<div className="status">
            {this.props.message?.isEmailNotificationFailed && <div>{this.props.message?.isEmailNotificationFailed ? `${this.trans("status-email-notification-failed")}` : ``}</div>}
            {this.props.message?.isSmsNotificationFailed && <div>{this.props.message?.isSmsNotificationFailed ? `${this.trans("status-sms-notification-failed")}` : ``}</div>}
          </div>
				</div>
			</div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Message
);
